// @flow
import type {DataTables} from 'datatables.net';

export default function dateFormat(column: String, options: any,
        dtSettings: DataTables.Settings, component: JQuery) {
}